module.exports = __webpack_public_path__ + "img/Botella-Proceso-Elaboracion.97707a68.png";